import React from "react";
import ProgressBar from "../../../common/components/ProgressBar";
import {
  StyledFileUploadProgress,
  SecondaryText,
  FormatBadge,
  CancelButton,
} from "./styled";

interface Props {
  label?: string;
  title: string;
  progress: number;
  size: string;
  onCancel: () => void;
}

const FileUploadProgress = ({
  label,
  title,
  progress,
  size,
  onCancel,
}: Props) => {
  return (
    <StyledFileUploadProgress>
      <div>
        <div>
          <SecondaryText>Uploading {title}</SecondaryText>
          <SecondaryText>{Number(progress).toFixed(0)}%</SecondaryText>
        </div>
        <ProgressBar duration={100} progress={progress} step={1} />
        <div>
          {label && <FormatBadge>{label}</FormatBadge>}
          <SecondaryText>{size}</SecondaryText>
        </div>
      </div>
      <CancelButton onClick={onCancel} />
    </StyledFileUploadProgress>
  );
};

export default FileUploadProgress;
